require('../../node_modules/jarallax/dist/jarallax');

// Jarallax
if (window.screen.width > 768){
jarallax(document.querySelectorAll('.jarallax'), {
    speed: 0.2
});
}

// Menu
let app = {
    // menu mobile
	burger : document.querySelector('.menu__open'),
	close : document.querySelector('.menu__close'),
	toggleMenu: document.querySelector('.menu'),
  
  // Scroll top
  domHeaderHeight: document.querySelector('header').offsetHeight,
  domButton: document.querySelector('.scrollTop'),


    init: function () {
		console.log('init');
      // menu mobile
      app.burger.addEventListener('click',app.toggle);
      app.close.addEventListener('click', app.toggle2);

      // Scroll top
      window.addEventListener('scroll', app.seeButton);

    },

	// menu mobile
	toggle: function(){
		app.toggleMenu.classList.toggle("hidden");
	},
	
	toggle2: function(){
		app.toggleMenu.classList.toggle("hidden");
	},

    
    // Scroll top
    seeButton: function(){
      if(window.scrollY > app.domHeaderHeight){
        app.domButton.classList.remove("hidden");
      }else{
        app.domButton.classList.add("hidden");
      }
    },
};
document.addEventListener('DOMContentLoaded',app.init);
//Vanilla JavaScript Scroll to Anchor
//@ https://perishablepress.com/vanilla-javascript-scroll-anchor/

(function() {
	scrollTo();
})();

function scrollTo() {
	const links = document.querySelectorAll('.scroll');
	links.forEach(each => (each.onclick = scrollAnchors));
}

function scrollAnchors(e, respond = null) {
	const distanceToTop = el => Math.floor(el.getBoundingClientRect().top);
	e.preventDefault();
	var targetID = (respond) ? respond.getAttribute('href') : this.getAttribute('href');
	const targetAnchor = document.querySelector(targetID);
	if (!targetAnchor) return;
	const originalTop = distanceToTop(targetAnchor);
	window.scrollBy({ top: originalTop, left: 0, behavior: 'smooth' });
	const checkIfDone = setInterval(function() {
		const atBottom = window.innerHeight + window.pageYOffset >= document.body.offsetHeight - 2;
		if (distanceToTop(targetAnchor) === 0 || atBottom) {
			targetAnchor.tabIndex = '-1';
			window.history.pushState('', '', targetID);
			clearInterval(checkIfDone);
		}
	}, 100);
}

function scrollTo() {
	var links = document.getElementsByTagName('a');
	for (var i = 0; i < links.length; i++) {
		var link = links[i];
		if ((link.href && link.href.indexOf('#') != -1) && ((link.pathname == location.pathname) || ('/' + link.pathname == location.pathname)) && (link.search == location.search)) {
			link.onclick = scrollAnchors;
		}
	}
}